import { WorkOrder } from '@idea2app/ai-work-order-service';
import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';

import { t } from '../model/Translation';

export const WorkOrderInfo: FC<WorkOrder> = ({
    orderNumber,
    category,
    department,
    acceptanceTime,
    uploadTime,
    processingStatus,
    acceptanceContent
}) => (
    <>
        <h5 className="mb-3">{t('work_order_original_info')}</h5>
        <Row className="mb-3">
            <Col md={4}>
                {t('order_number')}：
                <span className="text-primary fw-bold">{orderNumber}</span>
            </Col>
            <Col md={4}>
                {t('category')}：{category?.level1Category || '-'}
            </Col>
            <Col md={4}>
                {t('unit_name')}：{department}
            </Col>
        </Row>
        <Row className="mb-3">
            <Col md={4}>{t('primary_category')}：非电力故障</Col>
            <Col md={4}>{t('secondary_category')}：第三方原因</Col>
            <Col md={4}>{t('tertiary_category')}：非直供户</Col>
        </Row>
        <Row className="mb-3">
            <Col md={4}>
                {t('order_completion_time')}：
                {acceptanceTime
                    ? new Date(acceptanceTime).toLocaleString()
                    : '-'}
            </Col>
            <Col md={4}>
                {t('return_timestamp')}：
                {uploadTime ? new Date(uploadTime).toLocaleString() : '-'}
            </Col>
            <Col md={4}>{t('processing_result')}：处理完毕</Col>
        </Row>
        <Row className="mb-4">
            <Col>
                {t('processing_situation')}：{processingStatus}
            </Col>
        </Row>
        <Row className="mb-4">
            <Col>
                {t('acceptance_content')}：{acceptanceContent}
            </Col>
        </Row>
    </>
);
